export default "__VITE_ASSET__566b6553__"